var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"导入","width":"700px","visible":_vm.dialogVisible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('upload-excel',{attrs:{"on-success":_vm.onSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }